<template>
    <div class="container-fluid">
        <ToastTemplet :bus="toast"></ToastTemplet>
        <div class="row mt-5">
            <div class="col-md-12">
            <div class="card">
              <div class="card-header">
                  <div class="row">
                <div class="col-md-3">
                    <div class="form-group">
                        <label>Executive </label>
                        <multiselect
                            v-model="GlobalEmployee"
                            :options="employee_master"
                            :allow-empty="true"
                            open-direction="bottom"
                            deselect-label="Can't remove this value"
                            :custom-label="customLabel"
                            track-by="EMPLOYEE_ID"
                            :close-on-select="true"
                            aria-required="true">
                        </multiselect>
                    </div>
                </div>
                <div class="col-md-2">
                    <div class="form-group">
                        <label>Bank </label>
                        <multiselect
                            v-model="GlobalBank"
                            :options="bank_master"
                            :allow-empty="true"
                            open-direction="bottom"
                            deselect-label="Can't remove this value"
                            track-by="BANK_ID"
                            label = "Bank_Name"
                            :show-labels="false"
                            @input="afterBankSelect"
                            :close-on-select="true"
                            aria-required="true">
                        </multiselect>
                    </div>
                </div>
                <div class="col-md-2">
                    <div class="form-group">
                        <label>Branch Code</label>
                        <multiselect
                            v-model="GlobalBankBranch"
                            :options="Bank_Branch_Master_For_Bank"
                            :allow-empty="true"
                            open-direction="bottom"
                            deselect-label="Can't remove this value"
                            track-by="BANK_BRACH_ID"
                            label = "Bank_Branch_Code"
                            :close-on-select="true"
                            :show-labels="false"
                            aria-required="true">
                        </multiselect>
                    </div>
                </div>
                <div class="col-md-2">
                    <div class="form-group">
                        <label> Product </label>
                        <multiselect
                            v-model="GlobalProduct"
                            :options="Product_Master_For_Bank"
                            :allow-empty="true"
                            open-direction="bottom"
                            deselect-label="Can't remove this value"
                            track-by="PRODUCT_ID"
                            label = "Product_Name"
                            :close-on-select="true"
                            :show-labels="false"
                            aria-required="true">
                        </multiselect>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="form-group">
                        <label>Location</label>
                        <multiselect
                                v-model="Location"
                                :options="Location_Master"
                                :allow-empty="false"
                                open-direction="bottom"
                                deselect-label="Can't remove this value"
                                aria-required="true">
                        </multiselect>
                    </div>
                </div>
                <div class="col-md-2">
                    <div class="form-group">
                        <label>Verify Start Date </label>
                        <input type="date" v-model="startDate"/>
                    </div>
                </div>
                <div class="col-md-2">
                    <div class="form-group">
                        <label>Verify End Date </label>
                        <input type="date" v-model="endDate"/>
                    </div>
                </div>
                <div class="col-md-4" >
                    <div class="form-group">
                        <label> Admins  </label>
                        <multiselect
                            v-model="GlobalAdmin"
                            :options="Admin_Master"
                            :allow-empty="true"
                            open-direction="bottom"
                            deselect-label="Can't remove this value"
                            track-by="id"
                            label = "name"
                            :close-on-select="true"
                            aria-required="true">
                        </multiselect>
                    </div>
                </div>
                <div class="col-md-1 col-xs-2 column bt-column2">
                    <div class="form-group">
                        <button class="btn btn-success" @click="loadAndSearchClientForAddBCPList(1)">Submit</button>
                    </div>
                </div>

              </div>
            </div>
            </div>
            </div>
        </div>
        <div class="row mt-5">
          <div class="col-md-12">
            <div class="card">
              <div class="card-header">
                <h3 class="card-title">BCP List Total:- {{ BCPTotalCount }}</h3>

                <div class="card-tools">

                    <input class="btn search_box" type="text" placeholder="LoginId/Applicant" @keyup="searchit" v-model="search" aria-label="Search">
                </div>
              </div>
              <!-- /.card-header -->
              <div class="card-body table-responsive p-0">
                        <table class="table table-hover">
                        <tr>
                            <th>Login Id</th>
                            <th>Bank Name</th>
                            <th>Branch Code</th>
                            <th>Product Name</th>
                            <th>Applicant Name</th>
                            <th>Executive</th>
                            <th>Location</th>
                            <th>Location Type</th>
                            <th>Address</th>
                            <th>Mobile Number</th>
                            <th>Created At</th>
                            <th>Allocated At</th>
                            <th>Verify At</th>
                            <th>Details</th>
                        </tr>
                        <tr v-for="(client_master, i) in client_masters.data" :key="client_master.ECV_ID" v-bind:id="i">
                                <td> {{ client_master.Login_Id}} </td>
                                <td> {{ client_master.Bank_Name}} </td>
                                <td> {{ client_master.Bank_Branch_Code}} </td>
                                <td> {{ client_master.Product_Name}} </td>
                                <td> {{ client_master.Applicant_Name}} </td>
                                <td v-if="client_master.Employee_First_Name != null"> {{ client_master.Employee_First_Name}} {{ client_master.Employee_Last_Name}} ({{ client_master.Employee_User_Id}})</td> <td v-if="client_master.Employee_First_Name == null"> NULL </td>
                                <td> {{ client_master.Location}} </td>
                                <td v-if="client_master.Location_Type != null"> {{ client_master.Location_Type}} </td> <td v-if="client_master.Location_Type == null"> NULL </td>
                                <td v-if="client_master.Residential_Address != null"> {{ client_master.Residential_Address}} </td> <td v-else-if="client_master.Office_Address != null"> {{ client_master.Office_Address}} </td> <td v-else> NULL </td>
                                <td v-if="client_master.Contact_Person_Mobile_Number != null"> {{ client_master.Contact_Person_Mobile_Number}} </td> <td v-else-if="client_master.Office_Mobile_Number != null"> {{ client_master.Office_Mobile_Number}} </td> <td v-else> NULL </td>
                                <td> {{ customDateFormatter(client_master.created_at) }} </td>
                                <td> {{ customDateFormatter(client_master.AssignDate) }} </td>
                                <td> {{ customDateFormatter(client_master.Verify_at) }} </td>
                                <td v-if="client_master.BCP_ID == null" > <a href="#" @click="ViewClientInfo(client_master)" ><i class="fas fa-info-circle red"></i></a> </td>
                                <td v-if="client_master.BCP_ID != null"> <a href="#" @click="ViewClientInfo(client_master)" ><i class="fas fa-info-circle green"></i></a> </td>

                        </tr>
                        </table>
                    </div>
                    <!-- /.card-body -->
                    <div class="card-footer">
                        <div class="row">
                            <div class="col-md-9">
                                    <pagination :data="client_masters" @pagination-change-page="loadAndSearchClientForAddBCPList" :limit="this.$PaginationCounterLimit">
                                    <span slot="prev-nav">&lt; Previous</span>
                                    <span slot="next-nav">Next &gt;</span>
                                </pagination>
                            </div>
                            <div class="col-md-1 show-text">
                                Show
                            </div>
                            <div class="col-md-1 pagination">
                                <multiselect
                                    v-model="$PaginationLimit"
                                    :options="this.$PaginationOptions"
                                    :allow-empty="false"
                                    open-direction="top"
                                    :show-labels="false"
                                    @input="loadAndSearchClientForAddBCPList(1)"
                                    aria-required="true">
                                </multiselect>
                            </div>
                            <div class="col-md-1 entries-text">
                                Entries
                            </div>
                        </div>
                    </div>
                    </div>
                    <!-- /.card -->
                </div>
                </div><!-- /.row -->
    </div>
</template>

<script>
    import Toastselectedlet from "../widget/toast";
    export default {
        props : ['userglobaldata'],
        components: { Multiselect,Toastselectedlet },
        data(){
            return{
                toast: new Vue(),
                GlobalAdmin:'',
                Admin_Master:[],
                Product_Master_For_Bank:[],
                Bank_Branch_Master_For_Bank:[],
                Location:null,
                Location_Master:['local','out'],
                search:'',
                startDate:'',
                endDate:'',
                GlobalProduct:'',
                GlobalEmployee:'',
                GlobalBank:'',
                GlobalBankBranch:'',
                bank_master:[],
                bank_branch_master:[],
                employee_master:[],
                product_master:[],
                Totaldata:[],
                client_masters:{},
                BCPTotalCount:'',
                columns : [
                    {
                        label: "Login Id",
                        field: "Login_Id",
                    },
                    {
                        label: "Applicant Name",
                        field: "Applicant_Name",
                    },
                    {
                        label: "Bank Name",
                        field: "Bank_Name",
                    },
                    {
                        label: "Bank Branch Code",
                        field: "Bank_Branch_Code",
                    },
                    {
                        label: "Product Name",
                        field: "Product_Name",
                    },
                    {
                        label: "Executive First Name",
                        field: "Employee_First_Name",
                    },
                    {
                        label: "Executive Last Name",
                        field: "Employee_Last_Name",
                    },
                    {
                        label: "Employee User Id",
                        field: "Employee_User_Id",
                    },
                    {
                        label: "Location",
                        field: "Location",
                    },
                    {
                        label: "Location Type",
                        field: "Location_Type",
                    },
                    {
                        label: "Residential Address",
                        field: "Residential_Address",
                    },
                    {
                        label: "Residential Phone",
                        field: "Contact_Person_Mobile_Number",
                    },
                    {
                        label: "Office Address",
                        field: "Office_Address",
                    },
                    {
                        label: "Office Phone",
                        field: "Office_Mobile_Number",
                    },
                    {
                        label: "Created At",
                        field: "created_at",
                    },
                    {
                        label: "Visit At",
                        field: "Visit_Date_Time",
                    },
                    {
                        label: "Verify At",
                        field: "Verify_at",
                    },
                ],
            }
        },
        created() {
            Fire.$on('searching',()=>{
                this.loadAndSearchClientForAddBCPList();
            })
            Fire.$on('AfterChangeClient',()=>{
                this.loadAndSearchClientForAddBCPList();
            });
        },
        mounted(){
            this.loadEmployee()
            this.loadBank()
            this.loadAllProduct()
            this.loadBankBranch()
            this.loadAndSearchClientForAddBCPList()
            this.loadAdmins();
        },
        methods:{
            searchit: _.debounce(()=>{
                Fire.$emit('searching');
            },500),
            tableColor(Verify_at,created_at,AssignDate,i){
                console.log(Verify_at,created_at,AssignDate,i)
                if(Verify_at != null){
                    $('#'+i).addClass('table-success')
                }
                else if(AssignDate != null) {
                    $('#'+i).addClass('table-danger')
                } else {

                }
            },
            afterselect_bank()
            {
                axios.get('/afterselect_bank/'+ this.GlobalBank.BANK_ID)
                    .then(({data})=> {this.Bank_Branch_Master_For_Bank = data})
                    .catch(() => {
                        this.toast.$emit('ProgressBarFailerror',"Cannot Find Any data");
                    });
            },
            afterBankSelect(){
                this.afterselect_bank()
                axios.get('/loadProductBankWise/'+ this.GlobalBank.BANK_ID)
                    .then(({data})=> {this.Product_Master_For_Bank = data})
                    .catch(() => {
                        this.toast.$emit('ProgressBarFailerror',"Cannot Find Any data");
                    });
            },
            customLabel(option) {
                return `${option.Employee_First_Name} ${option.Employee_Last_Name}(${option.Employee_User_Id})`
            },
            ViewClientInfo(Data){
                this.$router.push({
                    name: "ClientInfo",
                    params: { ClientInfo: Data }
                });
            },
            loadBankBranch(){
                axios.get('/loadBankBranch')
                .then(({data})=> {this.bank_branch_master = data})
                .catch(() => {
                    this.toast.$emit('ProgressBarFailerror',"Cannot Find Any data");
                });
            },
            loadAdmins(){
                axios.get('/loadAdmins')
                .then(({data})=> {this.Admin_Master = data})
                .catch(() => {
                    this.toast.$emit('ProgressBarFailerror',"Cannot Find Any data");
                });
            },
            loadEmployee(){
                axios.get('/loadEmployee')
                .then(({data})=> {this.employee_master = data})
                .catch(() => {
                    this.toast.$emit('ProgressBarFailerror',"Cannot Find Any data");
                });
            },
            loadBank(){
                axios.get('/loadBank')
                .then(({data})=> {this.bank_master = data})
                .catch(() => {
                    this.toast.$emit('ProgressBarFailerror',"Cannot Find Any data");
                });
            },
            loadAllProduct(){
                axios.get('/loadAllProduct')
                    .then(({data})=> {this.product_master = data})
                    .catch(() => {
                        this.toast.$emit('ProgressBarFailerror',"Cannot Find Any data");
                    });
            },
            loadAndSearchClientForAddBCPList(page = 1) {
                var productid,bankid,employeeid,bankBranchId,AdminId,location;
                if(this.Location == null ) { location = "undefined"; } else { location = this.Location }
                if(this.GlobalAdmin == null ) { AdminId = "undefined"; } else { AdminId = this.GlobalAdmin.id }
                if(this.GlobalProduct == null ){ productid = "undefined"; } else { productid = this.GlobalProduct.PRODUCT_ID }
                if(this.GlobalBank == null ){ bankid = "undefined";} else { bankid = this.GlobalBank.BANK_ID }
                if(this.GlobalEmployee == null ){ employeeid = "undefined";} else { employeeid = this.GlobalEmployee.EMPLOYEE_ID }
                if(this.GlobalBankBranch == null ){ bankBranchId = "undefined"; } else {bankBranchId = this.GlobalBankBranch.BANK_BRANCH_ID }
                this.toast.$emit('ProgressBarLoading');
                axios
                    .get("loadAndSearchClientForAddBCPList?query=" + this.search +"&bankBranchId="+ bankBranchId +"&location="+location+"&adminId="+AdminId+"&page=" + page + "&PaginationLimit="+ this.$PaginationLimit + "&startDate="+ this.startDate + "&endDate="+ this.endDate + "&bankId="+ bankid + "&productId="+ productid + "&employeeid="+ employeeid)
                    .then(({ data }) => {
                        this.client_masters = data,
                        this.BCPTotalCount = data.total,
                        this.toast.$emit('ProgressBarFinish')
                    })
                    .catch(() => {
                        this.toast.$emit('ProgressBarFailerror',"Cannot Find Any Such User");
                    });
            },
        }
    }
</script>
